import React, { useEffect, useRef, useState } from 'react';
import { Box, Grid, Typography, Card, Container } from '@mui/material';
import { useMediaQueries } from '../../usecontext/UseProvider';
import { FaPlay } from 'react-icons/fa';
import { getCustomerReviewVideo } from '../../services/CustomerReviewVideo';

const HappyCustomer = () => {
    const { isSmallScreen, isMediumScreen, isLargeScreen } = useMediaQueries();
    const [customerReviewData, setCustomerReviewData] = useState([])

    const getCustomerReviewVideoData = async () => {
        try {
            const response = await getCustomerReviewVideo();
            setCustomerReviewData(response?.customerReviewVideo);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        getCustomerReviewVideoData();
    }, []);

    const videoRefs = useRef([]);
    const [isPlaying, setIsPlaying] = useState(
        Array(customerReviewData?.length).fill(false) // Initialize play state for all videos
    );

    const handlePlayPause = (index) => {
        const video = videoRefs.current[index];
        const updatedPlayingState = [...isPlaying];

        if (video.paused) {
            video.play();
            updatedPlayingState[index] = true;
        } else {
            video.pause();
            updatedPlayingState[index] = false;
        }

        setIsPlaying(updatedPlayingState); // Update the play state
    };

    const handleVideoEnd = (index) => {
        const updatedPlayingState = [...isPlaying];
        updatedPlayingState[index] = false; // Reset play state when the video ends
        setIsPlaying(updatedPlayingState);
    };

    return (
        <Container
            sx={{
                pt: { lg: 8, xs: 3 },
                pb: { lg: 12, xs: 3 },
                textAlign: 'center',
            }}
        >
            <Typography
                data-aos="fade-up"
                variant={isSmallScreen ? 'h6' : isMediumScreen ? 'h5' : 'h4'}
                sx={{ fontWeight: 700 }}
                gutterBottom
            >
                Our Happy Customer Reviews
            </Typography>
            <Typography data-aos="fade-up" variant="subtitle1" sx={{ mb: { lg: 6, xs: 3 } }}>
                To find out about our valued client’s experiences and level of
                {isLargeScreen ? '' : <br />}
                satisfaction with our goods, view video
            </Typography>
            <Grid container spacing={3}>
                {customerReviewData.map((video, index) => (
                    <Grid
                        item
                        xs={12}
                        sm={6}
                        lg={3}
                        key={index}
                        data-aos="zoom-in"
                        data-aos-delay={index * 200}
                    >
                        <Card
                            sx={{
                                borderRadius: '20px',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                flexDirection: 'column',
                                position: 'relative',
                                boxShadow: 'none'
                            }}
                        >
                            <Box
                                component="video"
                                ref={(el) => (videoRefs.current[index] = el)} // Assign ref dynamically
                                src={video?.video?.url}
                                loop={false}
                                muted
                                onEnded={() => handleVideoEnd(index)} // Reset state when video ends
                                sx={{
                                    borderRadius: '20px',
                                    height: '330px',
                                    maxWidth: { lg: '300px', xs: '100%' },
                                    objectFit: 'cover',
                                }}
                                onClick={() => handlePlayPause(index)} // Allow pause/play on video click
                            />
                            {!isPlaying[index] && ( // Only show the play button when the video is not playing
                                <Box
                                    onClick={() => handlePlayPause(index)} // Pass the index to identify the correct video
                                    sx={{
                                        position: 'absolute',
                                        left: '50%',
                                        top: '50%',
                                        transform: 'translate(-50%, -50%)',
                                        textAlign: 'center',
                                        color: '#fff',
                                        backgroundColor: 'rgba(0, 0, 0, 0.6)',
                                        borderRadius: '50%',
                                        width: '60px',
                                        height: '60px',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        cursor: 'pointer',
                                    }}
                                >
                                    <FaPlay style={{ height: '20px', width: '20px' }} />
                                </Box>
                            )}
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Container>
    );
};

export default HappyCustomer;